/**
 * @file 日付変換
 *
 */
'use strict';
import Common from '../Utils/Common';

/**
 * @classname ChangeDate
 * @classdesc 日付変換
 */
export default class ChangeDate {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ChangeDate.constructor');
		this._$year = $('[data-field-id=8] select');
		this._$month = $('[data-field-id=9] select');
		this._$day = $('[data-field-id=10] select');
		this._$year.addClass('changeDate');
		this._$month.addClass('changeDate');
		const today = new Date();
		const thisYear = today.getFullYear();
		let options = '<option value="">--</option>';
		for (let i = thisYear - 17; i <= thisYear - 5; i++) {
			options += `<option value=${i}>${i}</option>`;
		}
		options += '<option value="1996">その他</option>';
		this._$year.html(options);
		$('.changeDate').on('change', () => this.onChange());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeDate
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeDate.onChange');
		const year = parseInt(this._$year.val());
		const month = parseInt(this._$month.val());
		if(year && month){
			const day = Common.getDateFromYearMonth(year, month);
			let options = '<option value="">--</option>';
			for(let i = 1; i <= day; i++){
				options += `<option value="${i}">${i}</option>`;
			}
			this._$day.html(options);
		}else{
			this._$day.html('<option value="">--</option>');
		}
	};
}
